<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-50">
      <accom-list
        v-bind:accoms="accomList"
        v-on:addAccom="addAccom"
        v-on:viewAccom="viewAccom"
        v-on:deleteAccom="deleteAccom"
      ></accom-list>
    </div>
    <div class="md-layout-item md-size-50">
      <accom-tabs v-bind:accom="selectedAccom"></accom-tabs>
    </div>
  </div>
</template>

<script>
import accomApi from "@/services/api/accom";
import confirm from "@/helpers/deleteConfirm";

import _filter from "lodash/filter";
import _findIndex from "lodash/findIndex";

import Swal from "sweetalert2";

import AccomList from "./AccomList";
import AccomTabs from "./AccomTabs";

export default {
  components: {
    AccomList,
    AccomTabs
  },

  data() {
    return {
      selectedAccom: null,
      accomList: []
    };
  },

  methods: {
    getAccoms() {
      accomApi.getAccoms().then(response => {
        this.accomList = response.data;
      });
    },

    addAccom() {
      this.selectedAccom = {};
    },

    viewAccom(accom) {
      this.selectedAccom = { ...accom };
    },

    deleteAccom(accom) {
      confirm.delete(null).then(resp => {
        if (resp.value) {
          accomApi.deleteAccom(accom.id).then(response => {
            this.accomList = _filter(this.accomList, function(a) {
              return a.id !== accom.id;
            });

            this.$notify({
              timeout: 2500,
              message: "Deleted.",
              icon: "cancel",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger"
            });
          });
        }
      });
    },

    accomUpdated(updateInfo) {
      if (updateInfo.mode == "CREATE") {
        this.accomList.unshift(updateInfo.accom);
      } else {
        var index = _findIndex(this.accomList, {
          id: updateInfo.accom.id
        });
        this.accomList.splice(index, 1, updateInfo.accom);
      }

      this.selectedAccom = null;
    }
  },

  mounted() {
    this.getAccoms();
  }
};
</script>
